import * as constants from 'helper/constants';
import request from 'superagent';

export default class API {
  static responseV2(err, res, callback) {
    let status = constants.api.failure;

    if (res) {
      const resStatus = res.statusCode.toString();
      if (resStatus.startsWith('20') || (res.body && res.body.status === 'success')) {
        status = constants.api.success;
      } else if (resStatus === '401') {
        status = constants.api.unauthorized;
      }
    }

    callback({
      status,
      res,
      err,
    });
  }

  constructor(apiUrl, apiClientId, apiClientSecret) {
    this.token = null;
    this.apiUrl = apiUrl;
    this.apiClientId = apiClientId;
    this.apiClientSecret = apiClientSecret;
    this.language = navigator.language;
  }

  fetchUserDetails() {
    return new Promise((resolve) => {
      request
        .get(`${this.apiUrl}/users/me`)
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${this.token}`)
        .type('json')
        .end((err, res) => {
          return API.responseV2(err, res, resolve);
        });
    });
  }

  login(username, password) {
    return new Promise((resolve) => {
      request
        .post(`${this.apiUrl}/oauth2/token`)
        .type('form')
        .set('x-oauth-version', '2')
        .send({
          'grant_type': 'password',
          'scope': 'email',
          'client_id': this.apiClientId,
          'client_secret': this.apiClientSecret,
          'username': username,
          'password': password
        })
        .end((err, res) => {
          API.responseV2(err, res, resolve);
        });
    });
  }

  updateUser(attrs, callback) {
    request
      .patch(`${this.apiUrl}/users/me/update`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .send(attrs)
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  updateEmail(email, callback) {
    request
      .post(`${this.apiUrl}/users/me/email-update`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .send(email)
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  confirmUser(confirmationToken, callback) {
    request
      .post(`${this.apiUrl}/users/confirm`)
      .set('Content-Type', 'application/json')
      .type('json')
      .send(confirmationToken)
      .end((err, res) => {
        API.responseV2(err, res, callback);
      });
  }

  deleteUser(callback) {
    request
      .del(`${this.apiUrl}/users/me`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  dataExport(callback) {
    request
      .post(`${this.apiUrl}/users/me/export`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  dataImport(importData, callback) {
    request
      .post(`${this.apiUrl}/users/me/import`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .send(importData)
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  dataImportDate(callback) {
    request
      .get(`${this.apiUrl}/users/me/import/date`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${this.token}`)
      .type('json')
      .end((err, res) => {
        return API.responseV2(err, res, callback);
      });
  }

  signUp(attrs, callback) {
    request
      .post(`${this.apiUrl}/users`)
      .set('Content-Type', 'application/json')
      .type('json')
      .send(attrs)
      .end((err, res) => {
        API.responseV2(err, res, callback);
      });
  }

  resetPasswordRequest(email, callback) {
    request
      .post(`${this.apiUrl}/auth/reset-password`)
      .set('Content-Type', 'application/json')
      .type('json')
      .send({ email })
      .end((err, res) => {
        API.responseV2(err, res, callback);
      });
  }

  changePassword(token, password, callback) {
    request
      .post(`${this.apiUrl}/auth/change-password`)
      .set('Content-Type', 'application/json')
      .type('json')
      .send({ token, password })
      .end((err, res) => {
        API.responseV2(err, res, callback);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js